/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useEventListener = <T extends keyof DocumentEventMap>(
  event: T,
  handler: (event: DocumentEventMap[T]) => void,
  dependencies: any[] = [],
  object: any | Document = document
): void => {
  useEffect(() => {
    if (object) {
      object.addEventListener(event, handler);
      return () => {
        object.removeEventListener(event, handler);
      };
    }
  }, [event, handler, ...dependencies]);
};
